import { Iterable, fromJS } from 'immutable';

import { notEmpty } from './validators';

// Convert value to given type
export const toType = (value, type) => {
  switch (type) {
    case 'number': {
      return value != null && value !== '' ? Number(value) : null;
    }

    case 'string': {
      return notEmpty(value) ? value.toString() : '';
    }

    case 'boolean': {
      return !!value;
    }

    case 'array': {
      return Array.isArray(value) ? value : [value];
    }

    case 'List':
    case 'Map': {
      return fromJS(value);
    }

    case 'js': {
      return Iterable.isIterable(value) ? value.toJS() : value;
    }

    default: {
      return value;
    }
  }
};

export default toType;



// WEBPACK FOOTER //
// ./src/common/utils/toType.js